import { render, staticRenderFns } from "./cadpelagenspet.vue?vue&type=template&id=06f1ddcb&"
import script from "./cadpelagenspet.vue?vue&type=script&lang=js&"
export * from "./cadpelagenspet.vue?vue&type=script&lang=js&"
import style0 from "./cadpelagenspet.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports